import React from "react";
import { GameContext } from "../../context/GameContext";

const Pagination = () => {
  const {
    setCurrentQuestion,
    currentQuestion,
    isFlipped,
    setIsFlipped,
    checkAlreadyAnswerd,
  } = React.useContext(GameContext);

  const handleClick = (e) => {
    if (e.target.name === "forward") {
      const nextQuestion = currentQuestion + 1;
      checkAlreadyAnswerd(nextQuestion);
      setCurrentQuestion(nextQuestion);
    } else {
      const previousQuestion = currentQuestion - 1;
      checkAlreadyAnswerd(previousQuestion);
      setCurrentQuestion(previousQuestion);
      if (currentQuestion === 28 && isFlipped) {
        setIsFlipped(!isFlipped);
      }
    }
  };

  return (
    <nav className="question_nav">
      {currentQuestion === 0 ? null : (
        <button name="backward" onClick={handleClick}>
          Föregående fråga
        </button>
      )}

      {currentQuestion === 28 ? null : (
        <button name="forward" onClick={handleClick}>
          Nästa fråga
        </button>
      )}
    </nav>
  );
};

export default Pagination;
